import React, { useEffect } from 'react';
import RedirectingPage from '@app/site/system/page/RedirectingPage';
import IntegrationService from '@app/model/integration/service/IntegrationService';
import { useQuery } from '@tanstack/react-query';
import { useSearchParam } from 'react-use';
import useSiteState from '@app/state/SiteState';
import RedirectingOKPage from '@app/site/system/page/RedirectingOKPage';
import SignInPage from '@app/site/authentication/page/SignInPage';
import WebhotelierOutput from '@app/model/integration/WebhotelierOutput';
import SecurityService from '@app/model/_security/service/SecurityService';

const WebHotelierPage = React.memo(() => {

	const token = useSearchParam('token')!;
	const htlCode = useSearchParam('htl_code')!;

	const { data, isLoading, isSuccess, isError } = useQuery({
		queryFn: () => IntegrationService.parseWebhotelierToken(token, htlCode),
		queryKey: [],
		retry: false,
	});

	if (isLoading) return <RedirectingPage />;
	if (isError) return <SignInPage />;
	else if (isSuccess)
		return <Redirect output={data} />;
	return <></>;

});

const Redirect: React.FunctionComponent<{ output: WebhotelierOutput }> = ({ output }) => {
	const siteState = useSiteState();
	useEffect(() => {
		siteState.setSelectedCompanyHotelId(undefined)
		siteState.setToken(output.principalWithToken.token);
		siteState.setPrincipal(output.principalWithToken.principal);
		SecurityService.relayToExtension(output.principalWithToken.token, output.principalWithToken.principal);
	}, []);

	return <RedirectingOKPage webhotelierId={output.webhotelierId} />;
};

export default WebHotelierPage;